var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BravadoTheme',{staticClass:"layout layout--clear"},[_c('div',{class:_vm.rootClass},[_c('ClientOnly',[_c('TopNotification')],1),_vm._v(" "),(!_vm.hasJustCompletedOnboarding)?_c('WarRoomMobileAppBannerTop'):_vm._e(),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('GlobalComponents')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }